import React from "react";
import "../ViewSpecialOnBoarding.css";
import SpecialOnBoardingCardComponent from "./SpecialOnBoardingCardComponent";
import Loader from "../../../../components/element/Loader";
import NoDataPlaceholder from "../../../../components/element/NoDataPlaceholder";
import ErrorPopup from "../../../../components/element/ErrorPopup";

const SpecialOnBoardingGridComponent = ({
  flightPlanData,
  onClickCard,
  isLoading,
  error,
  escortStatusData,
}) => {
  if (error) {
    if (error.status === 404) {
      return <NoDataPlaceholder />;
    } else {
      return <ErrorPopup children={error.message}></ErrorPopup>;
    }
  }

  if (isLoading) {
    return <Loader />;
  }

  if (flightPlanData && flightPlanData.data.content.length === 0) {
    return <NoDataPlaceholder />;
  }

  return (
    <div className="view-special-onboarding-grid-container">
      {flightPlanData?.data?.content.map(
        (item, index) => {
          // Extract flight plan data from the nested structure
          const flightPlan = item.cfp || item;
          
          // Get escort status data for this flight plan
          const flightPlanId = flightPlan.id;
          const escortData = escortStatusData?.[flightPlanId];
          
          return flightPlan.requiresEscortService && (
            <SpecialOnBoardingCardComponent
              key={index}
              item={item}
              onClickCard={() => onClickCard(item)}
              escortArrivalStatus={escortData?.arrivalStatus}
              escortDepartureStatus={escortData?.departureStatus}
            />
          );
        }
      )}
    </div>
  );
};

export default SpecialOnBoardingGridComponent;
